/**
 * Canonical site origin for SEO (sitemap, Open Graph, JSON-LD).
 * Set REACT_APP_SITE_URL in .env (e.g. https://bgstraps.shop or https://straps-60443.web.app).
 */
export function getSiteOrigin() {
    const raw = process.env.REACT_APP_SITE_URL || 'https://bgstraps.shop';
    return raw.replace(/\/$/, '');
}
